import CustomData from './CustomData';

export default CustomData;
